import { FC } from 'react'

import { commentaryMessageTypes } from '@sportworld/js-sdk/src/constants/common'
import {
  getCurrentMatchScore,
  getSoccerTeamLogo,
  isGoalMessageType,
} from '@sportworld/js-sdk/src/utils/soccerData'

import { MATCHES_COMMENTARY_COLUMNS } from '@/components/DataWidget/config'
import { MESSAGE_ICONS } from '@/components/DataWidget/constants'
import {
  Column,
  Icon,
  MatchCommentaryRow,
  MessageTime,
  MessageTitle,
} from '@/components/DataWidget/styles'
import { useCommonTranslation } from '@/i18n/useCommonTranslation'

import { MatchCommentaryProps } from '../types'

const columns = MATCHES_COMMENTARY_COLUMNS

export const MatchCommentary: FC<MatchCommentaryProps> = ({
  commentaryData,
  message,
}) => {
  const { t } = useCommonTranslation()

  const isGoalType = isGoalMessageType(message.type)
  const teamId = message.teamRef1
  const hasExtendedView = Object.values(commentaryMessageTypes).some(
    (type) => type === message.type,
  )

  const scoreText = isGoalType
    ? getCurrentMatchScore(commentaryData, message.id)
    : ''
  const headerText = t('dataWidget.commentary.' + message.type) + `${scoreText}`
  const timeLabel =
    message.time?.trim() &&
    message.time.replaceAll("'", '') + '. ' + t('dataWidget.commentary.minute')

  return (
    <MatchCommentaryRow key={message.id} $isLargeSize={isGoalType}>
      <Column $width={columns[0].width}>
        {hasExtendedView && (
          <Icon src={MESSAGE_ICONS[message.type]} alt={message.type} />
        )}
      </Column>
      <Column $width={columns[1].width}>
        <MessageTitle>{headerText}</MessageTitle>
        <MessageTime>{timeLabel}</MessageTime>
      </Column>
      <Column $width={columns[2].width}>{message.comment}</Column>
      <Column $width={columns[3].width}>
        {hasExtendedView && (
          <Icon src={getSoccerTeamLogo(teamId)} alt={teamId} />
        )}
      </Column>
    </MatchCommentaryRow>
  )
}
